import Stripe from "stripe";

// const ZEnv = z.enum(["development", "production", "preview", "test"]);

// export const ENV = ZEnv.parse(
//   process.env.NEXT_PUBLIC_VERCEL_ENV ||
//     process.env.VERCEL_ENV ||
//     process.env.NODE_ENV,
// );

const isProduction = true;

export const getPrice = (currency: string, tier: string) => {
  let price;

  if (tier === "basic") {
    price = 1.99;
  } else if (tier === "basic-discount") {
    price = 7.99;
  } else if (tier === "creator") {
    price = 9.99;
  } else if (tier === "creator-discount") {
    price = 24.99;
  } else if (tier === "power") {
    price = 89.99;
  } else {
    return null;
  }

  if (currency === "INR") {
    price = adjustPriceForINR(tier);
  }

  return price;
};

const adjustPriceForINR = (tier: string) => {
  const pricesInINR = {
    basic: 99,
    creator: 1249,
    "creator-discount": 1999,
    "basic-discount": 399,
    power: 4499,
  };

  return pricesInINR[tier as keyof typeof pricesInINR] || null;
};

// The welcome-back price (apps/web/lib/welcomeBack): Basic for someone whose
// plan ended, $4.99 a month for as long as they stay, and the same share of
// the local Basic price (4.99/8.99) elsewhere. Product "Jammable Welcome
// Back", created 2026-10-08. A secret plan like Early Adopter, so it's in
// earlyAdopterPlanId below (that list is what grants the plan).
export const welcomeBackPriceId: Record<string, string> = {
  usd: "price_1UOHfcCUwJnq3QQBOCxD45Xr", // 4.99
  eur: "price_1UOHfcCUwJnq3QQBfd7pqhdL", // 4.99
  gbp: "price_1UOHfdCUwJnq3QQBx9BqKnJz", // 4.99
  inr: "price_1UOHfdCUwJnq3QQBohZ8rYLX", // 219
  idr: "price_1UOHfdCUwJnq3QQBmD1agoGT", // 19000
  mxn: "price_1UOHfdCUwJnq3QQBR1X2og3A", // 39
  brl: "price_1UOHfeCUwJnq3QQBJXt7ABb2", // 6.99
  cad: "price_1UOHfeCUwJnq3QQB4hgGYB8R", // 6.49
  aud: "price_1UOHfeCUwJnq3QQB9UnfBy5m", // 6.99
  php: "price_1UOHffCUwJnq3QQBH1GKqK7t", // 139
  aed: "price_1UOHffCUwJnq3QQBhLuvWRn1", // 18.49
  sar: "price_1UOHffCUwJnq3QQBIUcaFVFq", // 18.49
  pln: "price_1UOHffCUwJnq3QQBTA8a5rtZ", // 19.49
  thb: "price_1UOHfgCUwJnq3QQBWjX1OJeK", // 79
  myr: "price_1UOHfgCUwJnq3QQBffcEDd1J", // 10.99
  jpy: "price_1UOHfgCUwJnq3QQBobTGbQZA", // 720
  krw: "price_1UOHfgCUwJnq3QQB68Ds7Jtx", // 6600
  chf: "price_1UOHfhCUwJnq3QQBBIzOjNMc", // 4.99
  ils: "price_1UOHfhCUwJnq3QQB3InoF29h", // 18.49
  sek: "price_1UOHfhCUwJnq3QQB7P4NDTQe", // 49
  sgd: "price_1UOHfhCUwJnq3QQBjnLGpkqv", // 6.49
  nzd: "price_1UOHfiCUwJnq3QQBXZrc0YHD", // 8.49
  cny: "price_1UOHfiCUwJnq3QQBbWI1Thjg", // 39
  try: "price_1UOHfiCUwJnq3QQBhyfLmzU4", // 139
  ars: "price_1UOHfiCUwJnq3QQBbt19JHVY", // 3900
  pen: "price_1UOHfjCUwJnq3QQBnwKGfhxP", // 8.49
  clp: "price_1UOHfjCUwJnq3QQB55OdnJ4k", // 2800
  cop: "price_1UOHfjCUwJnq3QQBYw6jJUha", // 7200
  ron: "price_1UOHfkCUwJnq3QQB5hY2zXF2", // 13.99
  vnd: "price_1UOHfkCUwJnq3QQBKqymDNzR", // 44000
  pkr: "price_1UOHfkCUwJnq3QQB4PIUOFhF", // 419
  uah: "price_1UOHfkCUwJnq3QQBNbDlPwtf", // 79
  egp: "price_1UOHflCUwJnq3QQBnlo29zf5", // 79
  bob: "price_1UOHflCUwJnq3QQBcA0kmZvs", // 22.99
  bdt: "price_1UOHflCUwJnq3QQB8zTpANB3", // 179
};

export const earlyAdopterPlanId = [
  "price_1NfQC7CUwJnq3QQBvRg8h9mQ", //USD MONTHLY

  "price_1NfQC7CUwJnq3QQBbViXalpE", //GBP MONTHLY

  "price_1NfQC7CUwJnq3QQBHMHe6Bwn", // EUR MONTHLY

  "price_1Nxt9gCUwJnq3QQBEril38wT",

  "price_1Nxt9xCUwJnq3QQBsd3D4Uoh",

  "price_1NxtABCUwJnq3QQBPKzNh0j5",

  "price_1OnQ84CUwJnq3QQBiPXNJwSD",

  "price_1OnQ8rCUwJnq3QQBOqH7iYez",

  "price_1OnQ92CUwJnq3QQBnckhJOAZ",

  "price_1R88ioCUwJnq3QQBCG079EYn",

  "price_1R88igCUwJnq3QQBBjzhHCev",

  "price_1R88iaCUwJnq3QQBJab6OLXJ",

  "price_1Raf4NCUwJnq3QQBCWWHBrBG",

  "price_1Raf57CUwJnq3QQB0zlYL2Do",

  "price_1Raf5HCUwJnq3QQBL1LK1rwu",
  // Secret plans in local currencies, offered by the cancel flow
  // (lib/cancelFlow). Added 2026-10.
  "price_1UNuHBCUwJnq3QQBnyHXrZya", // INR EARLY ADOPTER 109
  "price_1UNuHCCUwJnq3QQBFS7Q4ocL", // INR FOR EARLY ADOPTERS 49
  "price_1UNuHCCUwJnq3QQBlH1odioD", // IDR EARLY ADOPTER 9700
  "price_1UNuHCCUwJnq3QQB6WjvDwt3", // IDR FOR EARLY ADOPTERS 3900
  "price_1UNuHDCUwJnq3QQBbAR2IEWg", // MXN EARLY ADOPTER 19
  "price_1UNuHDCUwJnq3QQBL5cPQm8B", // MXN FOR EARLY ADOPTERS 10
  "price_1UNuHECUwJnq3QQBZyzSvvPd", // BRL EARLY ADOPTER 3.49
  "price_1UNuHECUwJnq3QQByscaBW5A", // BRL FOR EARLY ADOPTERS 1.49
  "price_1UNuHECUwJnq3QQBmQljTNjp", // CAD EARLY ADOPTER 3.49
  "price_1UNuHFCUwJnq3QQB545kwT7F", // CAD FOR EARLY ADOPTERS 1.49
  "price_1UNuHFCUwJnq3QQBpHXMvXEE", // AUD EARLY ADOPTER 3.49
  "price_1UNuHFCUwJnq3QQBvve9OTc2", // AUD FOR EARLY ADOPTERS 1.49
  "price_1UNuHGCUwJnq3QQBZR8KPbLn", // PHP EARLY ADOPTER 69
  "price_1UNuHGCUwJnq3QQB57cik54r", // PHP FOR EARLY ADOPTERS 29
  "price_1UNuHHCUwJnq3QQBHQP9jGTp", // AED EARLY ADOPTER 8.99
  "price_1UNuHHCUwJnq3QQBv6kDjGeD", // AED FOR EARLY ADOPTERS 3.49
  "price_1UNuHHCUwJnq3QQBE3iwZmJR", // SAR EARLY ADOPTER 8.99
  "price_1UNuHICUwJnq3QQBOPmdwH2H", // SAR FOR EARLY ADOPTERS 3.49
  "price_1UNuHICUwJnq3QQBTWQMwQoB", // PLN EARLY ADOPTER 9.49
  "price_1UNuHICUwJnq3QQBGo5w3xjY", // PLN FOR EARLY ADOPTERS 3.99
  "price_1UNuHJCUwJnq3QQB8Xn2tCBE", // THB EARLY ADOPTER 39
  "price_1UNuHJCUwJnq3QQB5bcD0HMm", // THB FOR EARLY ADOPTERS 19
  "price_1UNuHKCUwJnq3QQBk5wEHmlp", // MYR EARLY ADOPTER 5.49
  "price_1UNuHKCUwJnq3QQBMEC5bI6y", // MYR FOR EARLY ADOPTERS 2.49
  "price_1UNuHLCUwJnq3QQBTubz4RbC", // JPY EARLY ADOPTER 360
  "price_1UNuHLCUwJnq3QQBpNjUwvbK", // JPY FOR EARLY ADOPTERS 140
  "price_1UNuHLCUwJnq3QQByjbs3b68", // KRW EARLY ADOPTER 3300
  "price_1UNuHMCUwJnq3QQByLIbdORk", // KRW FOR EARLY ADOPTERS 1300
  "price_1UNuHMCUwJnq3QQBoLa5PTEg", // CHF EARLY ADOPTER 2.49
  "price_1UNuHMCUwJnq3QQB5k5V0KkU", // CHF FOR EARLY ADOPTERS 0.99
  "price_1UNuHNCUwJnq3QQBY9oUGot4", // ILS EARLY ADOPTER 8.99
  "price_1UNuHNCUwJnq3QQBRh0in59Y", // ILS FOR EARLY ADOPTERS 3.49
  "price_1UNuHOCUwJnq3QQBPCQLIMNa", // SEK EARLY ADOPTER 29
  "price_1UNuHOCUwJnq3QQBDGroYKfF", // SEK FOR EARLY ADOPTERS 9
  "price_1UNuHPCUwJnq3QQBwDTi4VOu", // SGD EARLY ADOPTER 3.49
  "price_1UNuHPCUwJnq3QQBGxy8h5DT", // SGD FOR EARLY ADOPTERS 1.49
  "price_1UNuHPCUwJnq3QQB3oZCl38N", // NZD EARLY ADOPTER 3.99
  "price_1UNuHQCUwJnq3QQBcVJLuSix", // NZD FOR EARLY ADOPTERS 1.49
  "price_1UNuHQCUwJnq3QQB2D5EAM2A", // CNY EARLY ADOPTER 19
  "price_1UNuHRCUwJnq3QQBObJMe5Sh", // CNY FOR EARLY ADOPTERS 8
  "price_1UNuHRCUwJnq3QQBMR6zuiVI", // TRY EARLY ADOPTER 69
  "price_1UNuHRCUwJnq3QQBpdfrRdyJ", // TRY FOR EARLY ADOPTERS 29
  "price_1UNuHSCUwJnq3QQB7xa5PzG0", // ARS EARLY ADOPTER 1900
  "price_1UNuHSCUwJnq3QQBHtXn8ukX", // ARS FOR EARLY ADOPTERS 779
  "price_1UNuHTCUwJnq3QQBwIPZqfTp", // PEN EARLY ADOPTER 3.99
  "price_1UNuHTCUwJnq3QQB9Ql9aABN", // PEN FOR EARLY ADOPTERS 1.49
  "price_1UNuHTCUwJnq3QQBFbjW5rIE", // CLP EARLY ADOPTER 1400
  "price_1UNuHUCUwJnq3QQBubp5B4EI", // CLP FOR EARLY ADOPTERS 560
  "price_1UNuHUCUwJnq3QQBWMkm9f9e", // COP EARLY ADOPTER 3600
  "price_1UNuHUCUwJnq3QQBiOTaj8xs", // COP FOR EARLY ADOPTERS 1400
  "price_1UNuHVCUwJnq3QQBrWFFr8TJ", // RON EARLY ADOPTER 6.99
  "price_1UNuHVCUwJnq3QQBt3WmaoIi", // RON FOR EARLY ADOPTERS 2.99
  "price_1UNuHWCUwJnq3QQBIrcPrFmZ", // VND EARLY ADOPTER 22000
  "price_1UNuHWCUwJnq3QQBwZNkTzQv", // VND FOR EARLY ADOPTERS 8800
  "price_1UNuHWCUwJnq3QQBsfNEZxnR", // PKR EARLY ADOPTER 209
  "price_1UNuHXCUwJnq3QQBFjD2AztK", // PKR FOR EARLY ADOPTERS 79
  "price_1UNuHXCUwJnq3QQBoVwNJr4k", // UAH EARLY ADOPTER 39
  "price_1UNuHXCUwJnq3QQBcI4lcp0u", // UAH FOR EARLY ADOPTERS 19
  "price_1UNuHYCUwJnq3QQBNyNW1rRP", // EGP EARLY ADOPTER 39
  "price_1UNuHYCUwJnq3QQB45A6noKn", // EGP FOR EARLY ADOPTERS 19
  "price_1UNuHZCUwJnq3QQBWioetAuF", // BOB EARLY ADOPTER 11.49
  "price_1UNuHZCUwJnq3QQBdSJlrCZx", // BOB FOR EARLY ADOPTERS 4.49
  "price_1UNuHaCUwJnq3QQBb4O9qcjk", // BDT EARLY ADOPTER 89
  "price_1UNuHaCUwJnq3QQBNnAkhxza", // BDT FOR EARLY ADOPTERS 39
  ...Object.values(welcomeBackPriceId),
];

export const basicPlanId = [
  "price_1NVMJTCUwJnq3QQBbxqgtALq", //USD MONTHLY

  "price_1NVMKmCUwJnq3QQBgJk67lD1", //GBP MONTHLY

  "price_1NVMKQCUwJnq3QQBWLra0VwZ", // EUR MONTHLY

  "price_1Nr1q2CUwJnq3QQBxrGQFU8s", //USD MONTHLY 7.99

  "price_1Nr1qBCUwJnq3QQBi6JNTOTa", //GBP MONTHLY 7.99

  "price_1Nr1qMCUwJnq3QQBU936IGwN", // EUR MONHTLY 7.99

  "price_1NxYHHCUwJnq3QQBe62v7xcL", // INR MONTHLY

  "price_1QwMT0CUwJnq3QQBSmScFedd", // IDR MONTHLY

  "price_1RBFLmCUwJnq3QQB894WigS4", //MXN MONTHLY

  "price_1RBFvaCUwJnq3QQB6g6qjEQu", //BRL MONTHLY

  "price_1Tb6iVCUwJnq3QQBO7YevEb7", //CAD MONTHLY

  "price_1Tb6inCUwJnq3QQBMnC5TiWb", //AUD MONTHLY

  "price_1Tb6itCUwJnq3QQBHQhbrFH3", //PHP MONTHLY

  "price_1Tb77gCUwJnq3QQBwxmH4rEM", //AED MONTHLY

  "price_1Tb77iCUwJnq3QQBHhkQfV64", //SAR MONTHLY

  "price_1Tb77jCUwJnq3QQBTpFXqBVw", //PLN MONTHLY

  "price_1Tb77lCUwJnq3QQBy2mViC3Z", //THB MONTHLY

  "price_1Tb77nCUwJnq3QQBaE7UaX2c", //MYR MONTHLY

  "price_1Tb77oCUwJnq3QQBYmeI3OfT", //JPY MONTHLY

  "price_1Tb77qCUwJnq3QQBlQoWZ6Ex", //KRW MONTHLY

  "price_1TbFxVCUwJnq3QQBuaCVmj5h", //CHF MONTHLY

  "price_1TbFxzCUwJnq3QQBxsxQD6zC", //ILS MONTHLY

  "price_1TbFy0CUwJnq3QQByIF0Tusf", //SEK MONTHLY

  "price_1TbFy2CUwJnq3QQBfo8qV3yB", //SGD MONTHLY

  "price_1TbFy4CUwJnq3QQBsL0KHfpt", //NZD MONTHLY

  "price_1TbFy6CUwJnq3QQB9QDgcflv", //CNY MONTHLY

  "price_1TbIsDCUwJnq3QQBYOHsZwEK", //GBP ANNUAL

  "price_1TbRalCUwJnq3QQB2WR5Ja0m", //USD ANNUAL

  "price_1TbSK0CUwJnq3QQBExF6VJvH", //EUR ANNUAL

  "price_1TbSKDCUwJnq3QQBY6IgjjH2", //CAD ANNUAL

  "price_1TbSKJCUwJnq3QQB6sBc49Wz", //AUD ANNUAL
  "price_1UNcY1CUwJnq3QQBCSDqnWrx", // INR ANNUAL (added 2026-10)
  "price_1UNcY1CUwJnq3QQBhR1GdkN4", // IDR ANNUAL (added 2026-10)
  "price_1UNcY2CUwJnq3QQBps77g8aQ", // MXN ANNUAL (added 2026-10)
  "price_1UNcY2CUwJnq3QQBWep867Cm", // BRL ANNUAL (added 2026-10)
  "price_1UNcY2CUwJnq3QQBFLGyin3J", // PHP ANNUAL (added 2026-10)
  "price_1UNcY2CUwJnq3QQBeRXcgReL", // AED ANNUAL (added 2026-10)
  "price_1UNcY3CUwJnq3QQB7SbvKcfZ", // SAR ANNUAL (added 2026-10)
  "price_1UNcY3CUwJnq3QQBvyigvDIk", // PLN ANNUAL (added 2026-10)
  "price_1UNcY3CUwJnq3QQBylwj50tv", // THB ANNUAL (added 2026-10)
  "price_1UNcY4CUwJnq3QQBBhdTSJUD", // MYR ANNUAL (added 2026-10)
  "price_1UNcY4CUwJnq3QQBkkPhsm0P", // JPY ANNUAL (added 2026-10)
  "price_1UNcY4CUwJnq3QQBDMpAz0Vt", // KRW ANNUAL (added 2026-10)
  "price_1UNcY4CUwJnq3QQBSXXFyvRX", // CHF ANNUAL (added 2026-10)
  "price_1UNcY5CUwJnq3QQBG0qpXWPd", // ILS ANNUAL (added 2026-10)
  "price_1UNcY5CUwJnq3QQBtCQETNo7", // SEK ANNUAL (added 2026-10)
  "price_1UNcY5CUwJnq3QQBJvpWPTlN", // SGD ANNUAL (added 2026-10)
  "price_1UNcY5CUwJnq3QQBF7PxTRrj", // NZD ANNUAL (added 2026-10)
  "price_1UNcY6CUwJnq3QQBQiCpO9TU", // CNY ANNUAL (added 2026-10)
  "price_1UNcY6CUwJnq3QQBk9kRxOPj", // TRY ANNUAL (added 2026-10)
  "price_1UNcY6CUwJnq3QQBvq4wMxf3", // ARS ANNUAL (added 2026-10)
  "price_1UNcY6CUwJnq3QQBaNPHuuvc", // PEN ANNUAL (added 2026-10)
  "price_1UNcY7CUwJnq3QQBGdEd9DFP", // CLP ANNUAL (added 2026-10)
  "price_1UNcY7CUwJnq3QQB7Pjf0E3L", // COP ANNUAL (added 2026-10)
  "price_1UNcY7CUwJnq3QQB4l8WLAHg", // RON ANNUAL (added 2026-10)
  "price_1UNcY7CUwJnq3QQBdQ5SRyMb", // VND ANNUAL (added 2026-10)
  "price_1UNcY8CUwJnq3QQBCokuVBlQ", // PKR ANNUAL (added 2026-10)
  "price_1UNcY8CUwJnq3QQBhFUG4mur", // UAH ANNUAL (added 2026-10)
  "price_1UNcY8CUwJnq3QQBdeDuclyn", // EGP ANNUAL (added 2026-10)
  "price_1UNcY9CUwJnq3QQBEqw87FUq", // BOB ANNUAL (added 2026-10)
  "price_1UNcY9CUwJnq3QQBbW7ufjBv", // BDT ANNUAL (added 2026-10)

  "price_1U082qCUwJnq3QQBT6iYrkiH", // TRY MONTHLY (added 2026-08)
  "price_1U082sCUwJnq3QQBhgY2aOET", // ARS MONTHLY (added 2026-08)
  "price_1U082tCUwJnq3QQBup3kbHUe", // PEN MONTHLY (added 2026-08)
  "price_1U082uCUwJnq3QQBeGOEJMqi", // CLP MONTHLY (added 2026-08)
  "price_1U082wCUwJnq3QQBaSzMctNr", // COP MONTHLY (added 2026-08)
  "price_1U082xCUwJnq3QQBISCegvYw", // RON MONTHLY (added 2026-08)
  "price_1U082yCUwJnq3QQBzzH7s4rI", // VND MONTHLY (added 2026-08)
  "price_1U092HCUwJnq3QQBheYK1FjS", // PKR MONTHLY (added 2026-08)
  "price_1U092ICUwJnq3QQBBJ7vfFfk", // UAH MONTHLY (added 2026-08)
  "price_1U092JCUwJnq3QQBnQrDXyaI", // EGP MONTHLY (added 2026-08)
  "price_1U092LCUwJnq3QQB4HuBEYHR", // BOB MONTHLY (added 2026-08)
  "price_1U092MCUwJnq3QQBQh360wZc", // BDT MONTHLY (added 2026-08)
];

export const creatorPlanId = [
  "price_1MwYlgCUwJnq3QQBaxn8t4Jf", //USD MONTHLY

  "price_1MwYlgCUwJnq3QQBqyd9oCiY", //USD YEARLY

  "price_1N7K8xCUwJnq3QQBHhm5Y4IU", //GBP MONTHLY

  "price_1N7K9RCUwJnq3QQBR8bgAacP", //GBP YEARLY

  "price_1N7K9xCUwJnq3QQBBiH8Uk5j", // EUR MONTHLY

  "price_1N7KALCUwJnq3QQBRKfVW6wb", // EUR YEARLY

  "price_1NxYHlCUwJnq3QQB0TTeBpXb", //INR MONTHLY

  "price_1QwN5PCUwJnq3QQBTiQSOFdz", // IDR MONTHLY
  "price_1RBEMkCUwJnq3QQBUC8h52zg", //MXN MONTHLY

  "price_1RBFv1CUwJnq3QQBO8UDfNzf", //BRL MONTHLY

  "price_1PrOlFCUwJnq3QQBqbMfS8QE", // USD SECRET MONTHLY

  "price_1PrOlYCUwJnq3QQBk2JKgmc8", //GBP SECRET MONTHLY

  "price_1PrOlYCUwJnq3QQBESmEWpyh", //EUR SECRET MONTHLY

  "price_1QwN5PCUwJnq3QQBTiQSOFdz", // IDR MONTHLY

  "price_1R870gCUwJnq3QQBJPStgn1F", //USD SECRET MONTHLY 8.99

  "price_1R870WCUwJnq3QQBGrip4305", //GBP SECRET MONTHLY 8.99

  "price_1R870rCUwJnq3QQBSShwDGHc", //EUR SECRET MONTHLY 8.99

  "price_1Tb6ikCUwJnq3QQB1az0xQBF", //CAD MONTHLY

  "price_1Tb6ipCUwJnq3QQBb16lssCE", //AUD MONTHLY

  "price_1Tb6iuCUwJnq3QQB6DtiKSw4", //PHP MONTHLY

  "price_1Tb77yCUwJnq3QQBY6BezgyJ", //AED MONTHLY

  "price_1Tb780CUwJnq3QQBOiTICfwr", //SAR MONTHLY

  "price_1Tb781CUwJnq3QQBLtNQps10", //PLN MONTHLY

  "price_1Tb783CUwJnq3QQBi6Bm4QgB", //THB MONTHLY

  "price_1Tb784CUwJnq3QQBx86Vvd5M", //MYR MONTHLY

  "price_1Tb786CUwJnq3QQBjKVDzcqg", //JPY MONTHLY

  "price_1Tb787CUwJnq3QQBOW96T3Cu", //KRW MONTHLY

  "price_1TbFyFCUwJnq3QQBewVwtWrB", //CHF MONTHLY

  "price_1TbFyHCUwJnq3QQBY8gk6z4D", //ILS MONTHLY

  "price_1TbFyICUwJnq3QQBX8TFeS3Q", //SEK MONTHLY

  "price_1TbFyKCUwJnq3QQBiPzPjtAo", //SGD MONTHLY

  "price_1TbFyMCUwJnq3QQBQEvfP4Qw", //NZD MONTHLY

  "price_1TbFyOCUwJnq3QQBGHI0e1CO", //CNY MONTHLY

  "price_1TbIsJCUwJnq3QQBHjig9KZ9", //GBP ANNUAL (£119.99)

  "price_1TbRasCUwJnq3QQBsrDZayqV", //USD ANNUAL ($119.99)

  "price_1TbSKACUwJnq3QQBO4kvgBIo", //EUR ANNUAL

  "price_1TbSKFCUwJnq3QQBEXLsAwF2", //CAD ANNUAL

  "price_1TbSKKCUwJnq3QQBHL17jXDV", //AUD ANNUAL

  "price_1U082rCUwJnq3QQBRGwDZ6Qt", // TRY MONTHLY (added 2026-08)
  "price_1U082sCUwJnq3QQBX9QPfjK0", // ARS MONTHLY (added 2026-08)
  "price_1U082uCUwJnq3QQBE40qwhiV", // PEN MONTHLY (added 2026-08)
  "price_1U082vCUwJnq3QQBXhc7fnjh", // CLP MONTHLY (added 2026-08)
  "price_1U082wCUwJnq3QQBmDek93Rn", // COP MONTHLY (added 2026-08)
  "price_1U082xCUwJnq3QQBSf97ocsO", // RON MONTHLY (added 2026-08)
  "price_1U082zCUwJnq3QQBzAZBLnQv", // VND MONTHLY (added 2026-08)
  "price_1U092HCUwJnq3QQBoibrvkLN", // PKR MONTHLY (added 2026-08)
  "price_1U092JCUwJnq3QQBkDOjoEvJ", // UAH MONTHLY (added 2026-08)
  "price_1U092KCUwJnq3QQB9cIsHP27", // EGP MONTHLY (added 2026-08)
  "price_1U092LCUwJnq3QQBYNPSZy37", // BOB MONTHLY (added 2026-08)
  "price_1U092MCUwJnq3QQBJdASZbPk", // BDT MONTHLY (added 2026-08)
  // Creator for the price of Basic in local currencies, offered by the
  // cancel flow (lib/cancelFlow). Added 2026-10.
  "price_1UNuHCCUwJnq3QQBQKkGbA2Z", // INR SECRET MONTHLY 399
  "price_1UNuHDCUwJnq3QQBuBd6M0qk", // IDR SECRET MONTHLY 35000
  "price_1UNuHDCUwJnq3QQBvh9c9SVa", // MXN SECRET MONTHLY 79
  "price_1UNuHECUwJnq3QQBOy8lkYQi", // BRL SECRET MONTHLY 12.99
  "price_1UNuHFCUwJnq3QQB1UdSWzuc", // CAD SECRET MONTHLY 11.99
  "price_1UNuHGCUwJnq3QQBEHHJ4IMt", // AUD SECRET MONTHLY 12.99
  "price_1UNuHGCUwJnq3QQBIZcbeRwG", // PHP SECRET MONTHLY 249
  "price_1UNuHHCUwJnq3QQBNbpkQrwj", // AED SECRET MONTHLY 32.99
  "price_1UNuHICUwJnq3QQBuKaVtUJM", // SAR SECRET MONTHLY 32.99
  "price_1UNuHJCUwJnq3QQB9QTAZ8ry", // PLN SECRET MONTHLY 34.99
  "price_1UNuHKCUwJnq3QQBOU9cAJGV", // THB SECRET MONTHLY 149
  "price_1UNuHKCUwJnq3QQBVyCpCa8D", // MYR SECRET MONTHLY 19.99
  "price_1UNuHLCUwJnq3QQBlTCUs51h", // JPY SECRET MONTHLY 1300
  "price_1UNuHMCUwJnq3QQBPYn0gG6X", // KRW SECRET MONTHLY 11900
  "price_1UNuHNCUwJnq3QQBLWx2RdUQ", // CHF SECRET MONTHLY 8.99
  "price_1UNuHOCUwJnq3QQBTrFt47BE", // ILS SECRET MONTHLY 32.99
  "price_1UNuHOCUwJnq3QQBSI8ZVAGI", // SEK SECRET MONTHLY 99
  "price_1UNuHPCUwJnq3QQBxwKAlOMw", // SGD SECRET MONTHLY 11.99
  "price_1UNuHQCUwJnq3QQBLXybjvvJ", // NZD SECRET MONTHLY 14.99
  "price_1UNuHRCUwJnq3QQBRLNajsNj", // CNY SECRET MONTHLY 68
  "price_1UNuHSCUwJnq3QQByPSJ6tKH", // TRY SECRET MONTHLY 249
  "price_1UNuHSCUwJnq3QQBovLjxs15", // ARS SECRET MONTHLY 6999
  "price_1UNuHTCUwJnq3QQBlhJg3vO5", // PEN SECRET MONTHLY 14.99
  "price_1UNuHUCUwJnq3QQBFt5ZXba2", // CLP SECRET MONTHLY 4990
  "price_1UNuHVCUwJnq3QQBljHJ5pEz", // COP SECRET MONTHLY 12900
  "price_1UNuHVCUwJnq3QQBwWPsuihp", // RON SECRET MONTHLY 24.99
  "price_1UNuHWCUwJnq3QQBT0a3rfTh", // VND SECRET MONTHLY 79000
  "price_1UNuHXCUwJnq3QQBDhKxrVxk", // PKR SECRET MONTHLY 749
  "price_1UNuHYCUwJnq3QQBFeFqdv8n", // UAH SECRET MONTHLY 139
  "price_1UNuHZCUwJnq3QQBwuQsBgMT", // EGP SECRET MONTHLY 139
  "price_1UNuHZCUwJnq3QQBiiMSSjbk", // BOB SECRET MONTHLY 40.99
  "price_1UNuHaCUwJnq3QQBAi7CAfYD", // BDT SECRET MONTHLY 329
];

export const powerPlanId = [
  "price_1MwYn7CUwJnq3QQB6mg34Jf9", //usd monthky

  "price_1N7KEkCUwJnq3QQB3EmjwmBP", //gbp monthly

  "price_1N7KFDCUwJnq3QQBzn08BY8B", //eur monthly

  "price_1NxYI3CUwJnq3QQB8MXWWU1a", //INR MONTHLY

  "price_1Tb6ilCUwJnq3QQBqD90yA2D", //CAD MONTHLY

  "price_1Tb6itCUwJnq3QQB5j3FyuoU", //AUD MONTHLY

  "price_1Tb6ivCUwJnq3QQB3iqjprYB", //PHP MONTHLY

  "price_1Tb78ECUwJnq3QQBpXr7lDd5", //AED MONTHLY

  "price_1Tb78GCUwJnq3QQB9JPFJzUM", //SAR MONTHLY

  "price_1Tb78ICUwJnq3QQBmpYxxYJc", //PLN MONTHLY

  "price_1Tb78JCUwJnq3QQBeirbAIjh", //THB MONTHLY

  "price_1Tb78LCUwJnq3QQBVBYwfTas", //MYR MONTHLY

  "price_1Tb78MCUwJnq3QQBXYxdCU6m", //JPY MONTHLY

  "price_1Tb78OCUwJnq3QQB2jkhPyuS", //KRW MONTHLY

  "price_1TbFyWCUwJnq3QQBzcoH8S98", //CHF MONTHLY

  "price_1TbFyXCUwJnq3QQBqffUuvcr", //ILS MONTHLY

  "price_1TbFyZCUwJnq3QQB515qmHC6", //SEK MONTHLY

  "price_1TbFybCUwJnq3QQBAlp4mgoR", //SGD MONTHLY

  "price_1TbFydCUwJnq3QQBywFye6UN", //NZD MONTHLY

  "price_1TbFyeCUwJnq3QQBreeO5rPn", //CNY MONTHLY

  "price_1TbIsKCUwJnq3QQBVgcmc5PF", //GBP ANNUAL

  "price_1TbRatCUwJnq3QQBzGD6vuzG", //USD ANNUAL

  "price_1TbSKCCUwJnq3QQBYwfl3GUd", //EUR ANNUAL

  "price_1TbSKHCUwJnq3QQBeIAhdMVZ", //CAD ANNUAL

  "price_1TbSKMCUwJnq3QQBSm2RTKHk", //AUD ANNUAL

  "price_1U082rCUwJnq3QQBW3ycL0r9", // TRY MONTHLY (added 2026-08)
  "price_1U082tCUwJnq3QQBqcEvPwhQ", // ARS MONTHLY (added 2026-08)
  "price_1U082uCUwJnq3QQBfE6RHpGc", // PEN MONTHLY (added 2026-08)
  "price_1U082vCUwJnq3QQByUjc6kYm", // CLP MONTHLY (added 2026-08)
  "price_1U082xCUwJnq3QQBzhc6nwqz", // COP MONTHLY (added 2026-08)
  "price_1U082yCUwJnq3QQBdK5oFaFP", // RON MONTHLY (added 2026-08)
  "price_1U082zCUwJnq3QQBeP0oanER", // VND MONTHLY (added 2026-08)
  "price_1U092ICUwJnq3QQBXe7bk4vq", // PKR MONTHLY (added 2026-08)
  "price_1U092JCUwJnq3QQBPz0DIWZr", // UAH MONTHLY (added 2026-08)
  "price_1U092KCUwJnq3QQBkPRKAjYn", // EGP MONTHLY (added 2026-08)
  "price_1U092MCUwJnq3QQBK2StVUXx", // BOB MONTHLY (added 2026-08)
  "price_1U092NCUwJnq3QQBjKfXeu6l", // BDT MONTHLY (added 2026-08)
];

interface Subscription {
  subscriptionId: string;
  planId: string;
  status: Stripe.Subscription.Status;
  periodEnd: Date;
}

export type PlanName = "free" | "basic" | "early adopter" | "creator" | "power";

export const getSubscriptionStatus = (
  subscriptions: Subscription | Subscription[],
): PlanName => {
  const plans = [subscriptions]
    .flat()
    .filter(Boolean) // Ensure subscriptions is always an array
    // trialing = Stripe free trial in progress (e.g. abandoned-checkout
    // recovery offer) — entitled like active, first charge at trial end.
    .filter(
      (subscription) =>
        subscription.status === "active" || subscription.status === "trialing",
    )
    .flatMap((sub) => sub.planId);

  if (plans.some((planId) => powerPlanId.includes(planId))) {
    return "power";
  }

  if (plans.some((planId) => creatorPlanId.includes(planId))) {
    return "creator";
  }

  if (plans.some((planId) => basicPlanId.includes(planId))) {
    return "basic";
  }

  if (plans.some((planId) => earlyAdopterPlanId.includes(planId))) {
    return "early adopter";
  }

  return "free";
};

export const getSubscriptionStatusSettings = (
  subscriptions: Subscription | Subscription[],
): PlanName => {
  const plans = [subscriptions]
    .flat()
    .filter(Boolean) // Ensure subscriptions is always an array
    .filter(
      (subscription) =>
        subscription.status === "active" ||
        subscription.status === "trialing" ||
        subscription.status === "past_due",
    )
    .flatMap((sub) => sub.planId);

  if (plans.some((planId) => powerPlanId.includes(planId))) {
    return "power";
  }

  if (plans.some((planId) => creatorPlanId.includes(planId))) {
    return "creator";
  }

  if (plans.some((planId) => basicPlanId.includes(planId))) {
    return "basic";
  }

  if (plans.some((planId) => earlyAdopterPlanId.includes(planId))) {
    return "early adopter";
  }

  return "free";
};
